import Vue from "vue";
import { getField, updateField } from "vuex-map-fields";
import { axiosCall } from "@/utils/axiosCall";

function initialState() {
  return {
    trackerOrganizationsByStatus: { loading: true, data: [] },
    trackerImpactedWorkers: { loading: true, data: [] },
    trackerOrganizationsByCountry: { loading: true, data: [] },
    trackerOrganizationsByRegion: { loading: true, data: [] },
    trackerOrganizationsBySector: { loading: true, data: [] },
    trackerOrganizationsByEconomicActivity: { loading: true, data: [] },
    trackerMultinationalOrganizations: { loading: true, data: [] },
    trackerEmployeesByOrganizationSize: { loading: true, data: [] },
    selectedTrackerRegionInWidget: null,
    trackerAll:{loading:true,data:[]},
    trackerFilters: {},
  };
}

const state = initialState;

const getters = {
  getTrackerOrganizationsByStatus: (state) =>
    state.trackerOrganizationsByStatus,
  getTrackerImpactedWorkers: (state) => state.trackerImpactedWorkers,
  getTrackerOrganizationsByCountry: (state) =>
    state.trackerOrganizationsByCountry,
  getTrackerTotalCountries: (state) =>
    state.trackerOrganizationsByCountry.data.reduce(
      (acc, current) => ++acc ,
      0
    ),
  getTrackerTotalOrganizationsByRegion: (state) =>
    state.trackerOrganizationsByRegion.data.reduce(
      (acc, current) => acc + current.count,
      0
    ),
  getTrackerOrganizationsByRegion: (state) =>
    state.trackerOrganizationsByRegion,
  getTrackerOrganizationsBySector: (state) =>
    state.trackerOrganizationsBySector,
  getTrackerTotalOrganizationsBySector: (state) =>
    state.trackerOrganizationsBySector.data.reduce(
      (acc, current) => acc +current.count ,
      0
    ),
  getTrackerOrganizationsByEconomicActivity: (state) =>
    state.trackerOrganizationsByEconomicActivity,
  getTrackerTotalOrganizationsByEconomicActivity: (state) =>
    state.trackerOrganizationsByEconomicActivity.data.reduce(
      (acc, current) => acc + current.count ,
      0
    ),
  getTrackerMultinationalOrganizations: (state) =>
    state.trackerMultinationalOrganizations,
  getSelectedTrackerRegionInWidget: (state) => state.selectedTrackerRegionInWidget,
  getTrackerEmployeesByOrganizationSize: (state) => state.trackerEmployeesByOrganizationSize,
  getTotalTrackerEmployeesByOrganizationSize: (state) => state.trackerEmployeesByOrganizationSize.data.reduce((acc, current) => acc + current.count,0),
  getTotalOrganizations: (state) => state.organizationsByStatus.data.reduce((acc, current) => acc + current.count,0),
  getTrackerAll: (state)=>state.trackerAll,
};

const actions = {
  SET_NEW_TRACKER_FILTERS: async ({ dispatch, commit }, data) => {
    commit("setTrackerFilters", data);
    dispatch("REFRESH_TRACKER_DASHBOARD");
  },
  REFRESH_TRACKER_DASHBOARD: async ({ dispatch }) => {
    dispatch("GET_TRACKER_ORGANIZATIONS_BY_STATUS");
    dispatch("GET_TRACKER_IMPACTED_WORKERS");
    dispatch("GET_TRACKER_ORGANIZATIONS_BY_COUNTRY");
    dispatch("GET_TRACKER_ORGANIZATIONS_BY_REGION");
    dispatch("GET_TRACKER_ORGANIZATIONS_BY_SECTOR");
    dispatch("GET_TRACKER_ORGANIZATIONS_BY_ECONOMIC_ACTIVITY");
    dispatch("GET_TRACKER_MULTINATIONAL_ORGANIZATIONS");
    dispatch("GET_TRACKER_ALL");
    dispatch("GET_TRACKER_EMPLOYEES_BY_ORGANIZATION_SIZE");
  },
  GET_TRACKER_ORGANIZATIONS_BY_STATUS: async ({ commit, state }) => {
    await commit("setLoadingTrackerOrganizationsByStatus", true);
    var resp = await axiosCall({
      url: "tracker-dashboard/organizations-by-status",
      method: "POST",
      data: state.trackerFilters,
    });

    commit("setTrackerOrganizationsByStatus", resp.data);
    commit("setLoadingTrackerOrganizationsByStatus", false);
  },
  GET_TRACKER_IMPACTED_WORKERS: async ({ commit, state }) => {
    await commit("setLoadingTrackerImpactedWorkers", true);
    var resp = await axiosCall({
      url: "tracker-dashboard/impacted-workers",
      method: "POST",
      data: state.trackerFilters,
    });

    commit("setTrackerImpactedWorkers", resp.data);
    commit("setLoadingTrackerImpactedWorkers", false);
  },
  GET_TRACKER_ORGANIZATIONS_BY_COUNTRY: async ({ commit, state }) => {
    await commit("setLoadingTrackerOrganizationsByCountry", true);
    var resp = await axiosCall({
      url: "tracker-dashboard/organizations-by-country",
      method: "POST",
      data: state.trackerFilters,
    });

    commit("setTrackerOrganizationsByCountry", resp.data);
    commit("setLoadingTrackerOrganizationsByCountry", false);
  },
  GET_TRACKER_ORGANIZATIONS_BY_REGION: async ({ commit, state }) => {
    await commit("setLoadingTrackerOrganizationsByRegion", true);
    var resp = await axiosCall({
      url: "tracker-dashboard/organizations-by-region",
      method: "POST",
      data: state.trackerFilters,
    });

    commit("setTrackerOrganizationsByRegion", resp.data);
    commit("setLoadingTrackerOrganizationsByRegion", false);
  },
  GET_TRACKER_ORGANIZATIONS_BY_SECTOR: async ({ commit, state }) => {
    await commit("setLoadingTrackerOrganizationsBySector", true);
    var resp = await axiosCall({
      url: "tracker-dashboard/organizations-by-sector",
      method: "POST",
      data: state.trackerFilters,
    });

    commit("setTrackerOrganizationsBySector", resp.data);
    commit("setLoadingTrackerOrganizationsBySector", false);
  },
  GET_TRACKER_ORGANIZATIONS_BY_ECONOMIC_ACTIVITY: async ({ commit, state }) => {
    await commit("setLoadingTrackerOrganizationsByEconomicActivity", true);
    var resp = await axiosCall({
      url: "tracker-dashboard/organizations-by-economic-activity",
      method: "POST",
      data: state.trackerFilters,
    });

    commit("setTrackerOrganizationsByEconomicActivity", resp.data);
    commit("setLoadingTrackerOrganizationsByEconomicActivity", false);
  },
  GET_TRACKER_MULTINATIONAL_ORGANIZATIONS: async ({ commit, state }) => {
    await commit("setLoadingTrackerMultinationalOrganizations", true);
    var resp = await axiosCall({
      url: "tracker-dashboard/multinational-organizations",
      method: "POST",
      data: state.trackerFilters,
    });

    commit("setTrackerMultinationalOrganizations", resp.data);
    commit("setLoadingTrackerMultinationalOrganizations", false);
  },
  GET_TRACKER_EMPLOYEES_BY_ORGANIZATION_SIZE: async ({ commit, state }) => {
    await commit("setLoadingTrackerEmployeesByOrganizationSize", true);
    var resp = await axiosCall({
      url: "tracker-dashboard/employees-by-organization-size",
      method: "POST",
      data: state.trackerFilters,
    });

    commit("setTrackerEmployeesByOrganizationSize", resp.data);
    commit("setLoadingTrackerEmployeesByOrganizationSize", false);
  },
  GET_TRACKER_ALL: async ({ commit, state }) => {
    await commit("setLoadingTrackerAll", true);
    var resp = await axiosCall({
      url: "tracker-dashboard/get-all",
      method: "POST",
      data: state.trackerFilters,
    });

    commit("setTrackerAll", resp.data);
    commit("setLoadingTrackerAll", false);
  },
};

const mutations = {
  setLoadingTrackerOrganizationsByStatus: (state, loading) => {
    state.trackerOrganizationsByStatus.loading = loading;
  },
  setTrackerOrganizationsByStatus: (state, data) => {
    state.trackerOrganizationsByStatus.data = data;
  },
  setLoadingTrackerImpactedWorkers: (state, loading) => {
    state.trackerImpactedWorkers.loading = loading;
  },
  setTrackerImpactedWorkers: (state, data) => {
    state.trackerImpactedWorkers.data = data;
  },
  setLoadingTrackerOrganizationsByCountry: (state, loading) => {
    state.trackerOrganizationsByCountry.loading = loading;
  },
  setTrackerOrganizationsByCountry: (state, data) => {
    state.trackerOrganizationsByCountry.data = data;
  },
  setLoadingTrackerOrganizationsByRegion: (state, loading) => {
    state.trackerOrganizationsByRegion.loading = loading;
  },
  setTrackerOrganizationsByRegion: (state, data) => {
    state.trackerOrganizationsByRegion.data = data;
  },
  setLoadingTrackerOrganizationsBySector: (state, loading) => {
    state.trackerOrganizationsBySector.loading = loading;
  },
  setTrackerOrganizationsBySector: (state, data) => {
    state.trackerOrganizationsBySector.data = data;
  },
  setLoadingTrackerOrganizationsByEconomicActivity: (state, loading) => {
    state.trackerOrganizationsByEconomicActivity.loading = loading;
  },
  setTrackerOrganizationsByEconomicActivity: (state, data) => {
    state.trackerOrganizationsByEconomicActivity.data = data;
  },
  setLoadingTrackerMultinationalOrganizations: (state, loading) => {
    state.trackerMultinationalOrganizations.loading = loading;
  },
  setTrackerMultinationalOrganizations: (state, data) => {
    state.trackerMultinationalOrganizations.data = data;
  },
  setLoadingTrackerEmployeesByOrganizationSize: (state, loading) => {
    state.trackerEmployeesByOrganizationSize.loading = loading;
  },
  setTrackerEmployeesByOrganizationSize: (state, data) => {
    state.trackerEmployeesByOrganizationSize.data = data;
  },
  setLoadingTrackerAll: (state, loading) => {
    state.trackerAll.loading = loading;
  },
  setTrackerAll: (state, data) => {
    state.trackerAll.data = data;
  },
  setSelectedTrackerRegionInWidget: (state, data) => {
    state.selectedTrackerRegionInWidget = data;
  },
  setTrackerFilters: (state, filters) => {
    state.trackerFilters = filters;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
